import React, { useState, useEffect, useContext } from 'react'
import '../../App.css';
import buttonMaltoBuza from '../../assets/chooseMaltoBuza.png'


function ButtonMaltoBuza(props) {

  return (
    <div >
      <img id = 'buttonBe' src = {buttonMaltoBuza} alt = 'MaltoBuza' onClick={(e) => props.clickMaltoBuza()} ></img>
    </div>
    );
  }

export default ButtonMaltoBuza;
